window.relationFormatter = function(value, row) {
    let html = '';
    if (value) {
        if (can('admin.relations.details')) {
            html += '<a href="/admin/relations/show/'+row.relation_id+'">';
            html += value;
            html += '</a>';
        } else {
            html += value;
        }
    }
    return html;
}
